import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { logout } from '../actions/authActions';


export class Header extends React.Component {
  _handleLogout = (e) => {
    e.preventDefault();
    this.props.logout();
  };

  render() {
    const { firstName, lastName, avatar, role, username, pageId } = this.props;
    const displayName = () => {
      if (!firstName && !lastName) {
        return username;
      } else {
        return `${firstName} ${lastName}`;
      }
    };
    return (
      <div>
        <header role="banner" id="header--puma" className={this.props.overlayVisible ? 'no-z-index' : ''}>
          <div className="container">
            <div className="logo">
              <Link to="/">
                <img src="/assets/img/UTSouthwestern-Medical-Group.svg" alt="UTSouthwestern Medical Center" />
              </Link>
            </div>

            <div className="account">
              Welcome, <a className="name">{displayName()}<img src={avatar} /></a>
              <div className="dropdown" id="acct_links">
                <ul>
                  {role === 'provider' && <li><NavLink exact to="/dashboard" activeClassName="active">Dashboard</NavLink></li>}
                  {role !== 'provider' && <li><NavLink exact to="/profiles" activeClassName="active">My Dashboard</NavLink></li>}
                  {role === 'provider' && pageId && <li><NavLink to={`/profiles/${pageId}`} activeClassName="active">My Profile</NavLink></li>}
                  {role === 'administrator' && <li><NavLink to="/liaisons" activeClassName="active">Manage Liaisons</NavLink></li>}
                  <li><a href={role === 'administrator' ? '/admin' : '/'} onClick={this._handleLogout}>Logout</a></li>
                </ul>
              </div>
            </div>
          </div>
        </header>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  username: state.auth.username,
  firstName: state.auth.firstName,
  lastName: state.auth.lastName,
  email: state.auth.email,
  avatar: state.auth.avatar,
  role: state.auth.role,
  overlayVisible: state.profile.overlayVisible,
  pageId: state.auth.pageId
});

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logout())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/Header.jsx